import { WidgetPosition } from 'ff/debrief/components/hud';

/**
 * Translates between percentage-based coordinates and pixel coordinates
 * Percentages are 0-1 values representing portion of total width/height
 *
 * Used by widgets to convert their internal percentage-based layout to pixels
 */
export class HudPositionTranslator {
    readonly xOffset: number = 0;
    readonly yOffset: number = 0;
    readonly containerHeight: number;
    readonly containerWidth: number;

    constructor(dimensions: { height: number; width: number }) {
        this.containerHeight = dimensions.height;
        this.containerWidth = dimensions.width;
    }

    /**
     * Convert X percentage (0-1) to pixels
     */
    x(percent: number): number {
        return percent * this.containerWidth;
    }

    /**
     * Convert Y percentage (0-1) to pixels
     */
    y(percent: number): number {
        return percent * this.containerHeight;
    }

    translate({ x, y, width, height }: WidgetPosition): {
        x: number;
        y: number;
        width: number;
        height: number;
    } {
        return {
            x: this.x(x),
            y: this.y(y),
            width: this.x(width),
            height: this.y(height),
        };
    }
}
